// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const buscarApartamentosService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/apto/info/empreendimentos`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const assinaturasArray = response.data.map((apartamento: any) => {
        return {
          key: apartamento.id,
          nome: apartamento.nome,
          empreendimento: apartamento.EmpreendimentoTable.nome,
          origem: apartamento.origem === 0 ? "Multicotas" : "Usuário",
          origemApto: apartamento.origem,
        };
      });

      return assinaturasArray;
    } catch (error) {
      console.error(error);
    }
  }
};
